module.exports = __webpack_public_path__ + "static/media/piano.e848a89c.svg";